import React from 'react'
import { navigateTo } from 'gatsby-link'
import styled, { css } from 'styled-components'
import { VelocityComponent } from 'velocity-react'
import Link from 'gatsby-link'

import { media } from '../../../styles/utils'
import { container, innerContainer, padding, hoverState, bgImage, bgIcon} from '../../../styles/global'

import { VideoPlayer } from '../../../components'


class BlockVideoPlayer extends React.Component {

	state = {

    }

	render() {
       
		return (

            <React.Fragment>

                <VideoPlayer 
                    data={this.props}
                />

            </React.Fragment> 
		)
	}
}



// layout
BlockVideoPlayer.wrapper = css`
	${innerContainer};
	margin-left: auto;
	margin-right: auto;

	${media.phone`
		flex-direction: column;
	`}
`


export default BlockVideoPlayer


// WEBPACK FOOTER //
// ./src/components/Block/templates/BlockVideoPlayer.js